import currencyEditComponent from './currency.edit.component';

export default angular
  .module('currency.edit', [])
  .component('currencyedit', currencyEditComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/edit/index.js